import React, { Component } from 'react';
import "./css/WMSAuthentication.css"
import { Loader } from './Widgets/Loader';

export class WMSAuthentication extends Component {

    constructor(props) {
        super(props);
        this.state = {
            netId: '',
            wmsPIN: '',
            loading: false
        };
        this.alertError = this.alertError.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.checkAuthentication = this.checkAuthentication.bind(this);
        this.checkAuthenticationCallback = this.checkAuthenticationCallback.bind(this);
    }


    //Automatically focus on the username input when the component mounts
    //when username is full, focus on password and vice versa
    //when both are full, submit the form
    componentDidMount() {
        document.getElementById("netId").focus();
        document.getElementById("netId").addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                var passwordInput = document.getElementById("wmsPIN");
                //if the password input is empty, focus on it otherwise submit the form
                if (passwordInput.value == "") {
                    passwordInput.focus();
                } else {
                    document.getElementById("login-submit").click();
                }

            }
        });
        document.getElementById("wmsPIN").addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                var loginInput = document.getElementById("netId");
                if (loginInput.value == "") {
                    loginInput.focus();
                } else {
                    document.getElementById("login-submit").click();
                }
            }
        });
    }

    alertError(message) {
        alert(message);
        this.setState({
            netId: '',
            wmsPIN: '',
            loading: false
        });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    checkAuthentication() {
        if (!this.state.netId) {
            alert("Please enter a Net ID");
        }
        else if (!this.state.wmsPIN) {
            alert("Please enter a PIN");
        }
        else {
            this.setState({ loading: true });
            this.checkAuthenticationCallback();
        }
    }



    async checkAuthenticationCallback() {
        await this.props.makeRESTCall(
            'wmsauthentication?netId=' + this.state.netId + '&wmsPIN=' + this.state.wmsPIN,
            'get',
            null,
            (checkAuthenticationInfo) => {
                if (checkAuthenticationInfo.success) {
                    if (checkAuthenticationInfo.isBYUEmployee && checkAuthenticationInfo.pinIsCorrect) {
                        this.props.authenticateUser(checkAuthenticationInfo.userId, checkAuthenticationInfo.userName, checkAuthenticationInfo.userPermissions, checkAuthenticationInfo.appPermissions);
                    }
                    else {
                        this.alertError("Your Net ID and PIN combination is incorrect");
                    }
                }
                else {
                    this.alertError(checkAuthenticationInfo.error);
                }
            },
            (title, error) => {
                this.alertError(error);
            },
            () => {
                this.setState({ loading: false });
            }
        );
    }

    render() {
        return (
            <div className="auth">
                {this.state.loading && <Loader />}
                <h1>WMS Login</h1>
                <label htmlFor="netId">BYU Net Id: </label>
                <input autoComplete="off" value={this.state.netId} type="text" id="netId" name="netId" onChange={this.handleInputChange}/><br/><br/>
                <label htmlFor="wmsPIN">WMS PIN: </label>
                <input autoComplete="off" value={this.state.wmsPIN} type="password" id="wmsPIN" name="wmsPIN" onChange={this.handleInputChange}/><br /><br />
                <button id="login-submit" onClick={this.checkAuthentication}>Submit</button>
            </div>
        );
    }
}
